import { transform } from "framer-motion"

export const fadeIn = (direction, delay, index) => {
    return {
        initial: {
            x: direction === 'right' ? -75 : direction === 'left' ? 75 : 50,
            opacity: 0
        },
        animate: {
            opacity: 1,
            x: 0,
            transition: {
                duration: 0.6,
                delay: (index && delay) ? index * delay : (delay && !index) ? delay : (index && !delay) ? 0.05 * index : 0.05,
            },
        },
    }
}

export const fadeUp = (duration, delay, index) => {
    return {
        initial: {
            y: 75,
            opacity: 0
        },
        animate: {
            opacity: 1,
            y: 0,
            transition: {
                duration: duration ?? 0.6,
                delay: (index && delay) ? index * delay : (delay && !index) ? delay : (index && !delay) ? 0.05 * index : 0.05,
            },
        },
    }
}